"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAllPlanningCategoriesType = exports.GetAllPlanning = exports.GetMapDetailByPlanningId = exports.SaveDataFilter = exports.SaveMapBase = exports.SaveHeaderForTable = exports.SaveInformationForTable = exports.SaveInfomationList = exports.GetListPlanningRelationByPlanningId = exports.GetAllPlanningBoundaries = exports.GetAllPlanningBoundariesGeomText = void 0;
var api_url_1 = require("../../../api/api-url");
var api_service_1 = require("../../../api/api-service");
var loading_store_1 = require("../loading/loading.store");
var api_handle_error_1 = require("../../../api/api-handle-error");
var Page500ErrorType = require("../../../common/error-types-500");
var index_1 = require("../../../index");
var map = require("../../../common/map");
var service = new api_service_1.default();
var SAVELOADINGDATASTATE = "MAPDATA/SAVELOADINGDATASTATE";
var SAVEMAPDATA = "MAPDATA/SAVEMAPDATA";
var SAVEPLANNINGRELATIONSHIP = "MAPDATA/SAVEPLANNINGRELATIONSHIP";
var SAVEINFOMATIONLIST = "MAPDATA/SAVEINFOMATIONLIST";
var SAVEINFOMATIONFORTABLE = "MAPDATA/SAVEINFOMATIONFORTABLE";
var SAVEHEADERFORTABLE = "MAPDATA/SAVEHEADERFORTABLE";
var SAVEDATAFILTER = "MAPDATA/SAVEDATAFILTER";
var SAVEPOLYGON = "MAPDATA/SAVEPOLYGON";
var SAVELISTPLANNING = "MAPDATA/SAVELISTPLANNING";
var SAVEPLANNINGCATEGORIESTYPE = "MAPDATA/SAVEPLANNINGCATEGORIESTYPE";
var SAVEPLANNINGCATEGORIESAll = "MAPDATA/SAVEPLANNINGCATEGORIESALL";
var MERGEDATABOUDARIESTOLIST = "MAPDATA/MERGEDATABOUDARIESTOLIST";
var SAVEALLBOUNDARIESOFALLPLANNING = "MAPDATA/SAVEALLBOUNDARIESOFALLPLANNING";
var LIST_BOUNDARIES = "MAPDATA/LIST_BOUNDARIES";
var SAVEMAPBASE = "MAPDATA/SAVEMAPBASE";
//--- config min max zoom
var getMaxZoomByPlanningTypeId = function (planningTypeId) {
    switch (planningTypeId) {
        case 2:
            return 20;
        case 1:
            return 20;
        case 3:
            return 20;
        default:
            return 20;
    }
};
var getMinZoomByPlanningTypeId = function (planningTypeId) {
    switch (planningTypeId) {
        case 2:
            return 1;
        case 1:
            return 12;
        case 3:
            return 14;
        default:
            return 1;
    }
};
var createMergeDataBoudariesToList = function (data) { return ({
    type: MERGEDATABOUDARIESTOLIST,
    data: data,
}); };
var createSavePlanningCategoriesAll = function (data) { return ({
    type: SAVEPLANNINGCATEGORIESAll,
    data: data,
}); };
var createSavePlanningCategoriesTypes = function (data) { return ({
    type: SAVEPLANNINGCATEGORIESTYPE,
    data: data,
}); };
var createSaveInfomationList = function (data) { return ({
    type: SAVEINFOMATIONLIST,
    data: data,
}); };
var createSaveInfomationForTable = function (data) { return ({
    type: SAVEINFOMATIONFORTABLE,
    data: data,
}); };
var createSaveHeaderForTable = function (data) { return ({
    type: SAVEHEADERFORTABLE,
    data: data,
}); };
var createSaveDataFilter = function (data) { return ({
    type: SAVEDATAFILTER,
    data: data,
}); };
var createListPolygon = function (data) { return ({
    type: SAVEPOLYGON,
    data: data,
}); };
var createSaveLoadingDataState = function (data) { return ({
    type: SAVELOADINGDATASTATE,
    data: data,
}); };
var createSaveMapData = function (data) { return ({
    type: SAVEMAPDATA,
    data: data,
}); };
var createMapBase = function (data) { return ({
    type: SAVEMAPBASE,
    data: data,
}); };
var createSavePlanningRelationship = function (data) { return ({
    type: SAVEPLANNINGRELATIONSHIP,
    data: data,
}); };
var createSaveAllBoundariesFromAllPlanning = function (data) { return ({
    type: SAVEALLBOUNDARIESOFALLPLANNING,
    data: data,
}); };
var intListBounds = function (data) { return ({
    type: LIST_BOUNDARIES,
    data: data,
}); };
//--- call api
exports.GetAllPlanningBoundariesGeomText = function () {
    return function (dispatch) {
        dispatch(loading_store_1.AddOneSlotToLoadingQueue);
        var params = new URLSearchParams();
        return service
            .get(api_url_1.ApiUrl.GetAllBoundariesOfAllPlanning, params)
            .then(function (res) {
            if (!res.err && res.content) {
                var arrCoordinatePolygon_1 = [];
                var ListBoundaries = res.content;
                ListBoundaries.map(function (boundariesObject) {
                    boundariesObject.minZoom = getMinZoomByPlanningTypeId(boundariesObject.planningTypeId);
                    boundariesObject.maxZoom = getMaxZoomByPlanningTypeId(boundariesObject.planningTypeId);
                    arrCoordinatePolygon_1.push(map.convertStringToArray(boundariesObject.geomText));
                });
                dispatch(createListPolygon(arrCoordinatePolygon_1));
            }
            else {
                // console.log("Error:" + res.err);
            }
            dispatch(intListBounds(res.content));
            return res;
        })
            .catch(function (err) {
            throw err;
        })
            .finally(function () {
            dispatch(loading_store_1.RemoveOneSlotToLoadingQueue);
        });
    };
};
exports.GetAllPlanningBoundaries = function () {
    return function (dispatch) {
        dispatch(loading_store_1.AddOneSlotToLoadingQueue);
        var params = new URLSearchParams();
        return service
            .get(api_url_1.ApiUrl.GetAllBoundariesOfAllPlanning, params)
            .then(function (res) {
            if (!res.err && res.content) {
                var ListBoundaries_1 = res.content;
                ListBoundaries_1.map(function (boundariesObject) {
                    boundariesObject.minZoom = getMinZoomByPlanningTypeId(boundariesObject.planningTypeId);
                    boundariesObject.maxZoom = getMaxZoomByPlanningTypeId(boundariesObject.planningTypeId);
                });
                if (ListBoundaries_1.length > 0) {
                    var idIntervalCheck_1 = setInterval(function () {
                        var openLayerController = index_1.store === null || index_1.store === void 0 ? void 0 : index_1.store.getState().openlayer.openLayerController;
                        if (openLayerController) {
                            openLayerController.functionDisplayAllBoundariesOfAllPlanning(ListBoundaries_1);
                            console.log("run run");
                            clearInterval(idIntervalCheck_1);
                        }
                    }, 250);
                }
            }
            else {
            }
            dispatch(intListBounds(res.content));
            return res;
        })
            .catch(function (err) {
            throw err;
        })
            .finally(function () {
            dispatch(loading_store_1.RemoveOneSlotToLoadingQueue);
        });
    };
};
// const convertStringToArray = (stringPolygon: string) => {
//   let arrCoordinatePolygon: number[][] = [];
//   if (!stringPolygon || stringPolygon.length < 8) return arrCoordinatePolygon;
//   const stringArray = stringPolygon.substring(9, stringPolygon.length - 2).split(",");
//   stringArray.map((string) => {
//     let arr = [];
//     const res = string.split(" ");
//     arr.push(parseFloat(res[1]));
//     arr.push(parseFloat(res[0]));
//     arrCoordinatePolygon.push(arr);
//   });
//   return arrCoordinatePolygon;
// };
exports.GetListPlanningRelationByPlanningId = function (planingId) {
    return function (dispatch) {
        dispatch(loading_store_1.AddOneSlotToLoadingQueue);
        var params = new URLSearchParams();
        params.append("id", String(planingId));
        return service
            .get(api_url_1.ApiUrl.GetPlanningRelationshipByPlanningId, params)
            .then(function (res) {
            if (!res.err && res.content) {
                var ResultContent = res.content;
                if (ResultContent)
                    dispatch(createSavePlanningRelationship(ResultContent));
            }
            else {
            }
            return res;
        })
            .catch(function (err) {
            api_handle_error_1.handleError500(err, Page500ErrorType.ERRORGETAPI);
        })
            .finally(function () {
            dispatch(loading_store_1.RemoveOneSlotToLoadingQueue);
        });
    };
};
exports.SaveInfomationList = function (data) {
    return function (dispatch) {
        dispatch(createSaveInfomationList(data));
    };
};
exports.SaveInformationForTable = function (data) {
    return function (dispatch) {
        dispatch(createSaveInfomationForTable(data));
    };
};
exports.SaveHeaderForTable = function (data) {
    return function (dispatch) {
        dispatch(createSaveHeaderForTable(data));
    };
};
exports.SaveMapBase = function (data) {
    return function (dispatch) {
        dispatch(createMapBase(data));
    };
};
exports.SaveDataFilter = function (data) {
    return function (dispatch) {
        dispatch(createSaveDataFilter(data));
    };
};
exports.GetMapDetailByPlanningId = function (planingId) {
    return function (dispatch) {
        dispatch(loading_store_1.AddOneSlotToLoadingQueue);
        dispatch(createSaveLoadingDataState(false));
        var params = new URLSearchParams();
        params.append("id", String(planingId));
        return service
            .get(api_url_1.ApiUrl.GetMapPlanningById, params)
            .then(function (res) {
            if (!res.err && res.content) {
                var ResultContent = res.content;
                if (ResultContent)
                    dispatch(createSaveMapData(ResultContent));
            }
            else {
                dispatch(createSaveMapData({
                    center: "",
                    extent: "",
                    id: 0,
                    "map_planning-relationship": [],
                    max_zoom: 0,
                    min_zoom: 0,
                    name: "",
                    planing_id: "",
                    projection: "",
                    z_index: 0,
                    zoom: 0,
                    map_setting: [],
                }));
            }
            dispatch(createSaveLoadingDataState(true));
            return res;
        })
            .catch(function (err) {
            api_handle_error_1.handleError500(err, Page500ErrorType.ERRORGETAPI);
        })
            .finally(function () {
            dispatch(loading_store_1.RemoveOneSlotToLoadingQueue);
        });
    };
};
exports.GetAllPlanning = function () {
    return function (dispatch) {
        dispatch(loading_store_1.AddOneSlotToLoadingQueue);
        var params = new URLSearchParams();
        return service
            .get(api_url_1.ApiUrl.GetAllPlanningByTypeId, params)
            .then(function (res) {
            if (!res.err && res.content) {
                var ResultContent = res.content;
                if (ResultContent.length > 0) {
                    var finalResul_1 = [];
                    ResultContent.map(function (planningObject) {
                        if (finalResul_1.length === 0) {
                            finalResul_1.push({
                                id: planningObject.planningTypeId,
                                name: planningObject.planningTypeName,
                                plannings: [__assign(__assign({}, planningObject), { nameTb: "", geomText: "" })],
                                minZoom: getMinZoomByPlanningTypeId(planningObject.planningTypeId),
                                maxZoom: getMaxZoomByPlanningTypeId(planningObject.planningTypeId),
                            });
                        }
                        else {
                            var categoriesIsNotExist_1 = true;
                            finalResul_1.map(function (planningCategories) {
                                if (planningCategories.id === planningObject.planningTypeId) {
                                    planningCategories.plannings.push(__assign(__assign({}, planningObject), { nameTb: "", geomText: "" }));
                                    categoriesIsNotExist_1 = false;
                                    return;
                                }
                            });
                            if (categoriesIsNotExist_1) {
                                finalResul_1.push({
                                    id: planningObject.planningTypeId,
                                    name: planningObject.planningTypeName,
                                    plannings: [
                                        __assign(__assign({}, planningObject), { nameTb: "", geomText: "" }),
                                    ],
                                    minZoom: getMinZoomByPlanningTypeId(planningObject.planningTypeId),
                                    maxZoom: getMaxZoomByPlanningTypeId(planningObject.planningTypeId),
                                });
                            }
                        }
                    });
                    dispatch(createSavePlanningCategoriesAll(finalResul_1));
                }
            }
            else {
                // console.log("Error:" + res.err);
            }
            return res;
        })
            .catch(function (err) {
            throw err;
        })
            .finally(function () {
            dispatch(loading_store_1.RemoveOneSlotToLoadingQueue);
        });
    };
};
exports.GetAllPlanningCategoriesType = function () {
    return function (dispatch) {
        dispatch(loading_store_1.AddOneSlotToLoadingQueue);
        var params = new URLSearchParams();
        return service
            .get(api_url_1.ApiUrl.PlanningType, params)
            .then(function (res) {
            if (!res.err && res.content) {
                var ResultContent = res.content;
                if (ResultContent.length > 0)
                    dispatch(createSavePlanningCategoriesTypes(ResultContent));
            }
            else {
                // console.log("Error:" + res.err);
            }
            return res;
        })
            .catch(function (err) {
            throw err;
        })
            .finally(function () {
            dispatch(loading_store_1.RemoveOneSlotToLoadingQueue);
        });
    };
};
var InitState = {
    hasLoadingData: false,
    mapData: {
        center: "0,0",
        extent: "0,0,0,0",
        id: -1,
        "map_planning-relationship": [],
        map_setting: [],
        max_zoom: 20,
        min_zoom: 10,
        name: "",
        planing_id: -1,
        projection: "EPSG:4326",
        z_index: 0,
        zoom: 14,
    },
    planningRelationShips: [],
    map: {},
    infomations: [],
    dataForTable: [],
    dataFilter: {},
    listPlanning: [],
    listPlanningCategories: [],
    listPlanningCategoriesAll: [],
    listPlanningBoundaries: [],
    headerTable: [],
    listPolygon: [],
};
function MapDataReducer(state, action) {
    if (state === void 0) { state = InitState; }
    switch (action.type) {
        case SAVELOADINGDATASTATE:
            return __assign(__assign({}, state), { hasLoadingData: action.data });
        case SAVEMAPDATA:
            return __assign(__assign({}, state), { mapData: action.data });
        case SAVEPLANNINGRELATIONSHIP:
            return __assign(__assign({}, state), { planningRelationShips: action.data });
        case SAVELISTPLANNING:
            return __assign(__assign({}, state), { listPlanning: action.data });
        case SAVEPLANNINGCATEGORIESTYPE:
            return __assign(__assign({}, state), { listPlanningCategories: action.data });
        case SAVEPLANNINGCATEGORIESAll:
            return __assign(__assign({}, state), { listPlanningCategoriesAll: action.data });
        case SAVEINFOMATIONLIST:
            return __assign(__assign({}, state), { infomations: action.data });
        case SAVEINFOMATIONFORTABLE:
            return __assign(__assign({}, state), { dataForTable: action.data });
        case SAVEHEADERFORTABLE:
            return __assign(__assign({}, state), { headerTable: action.data });
        case SAVEMAPBASE:
            return __assign(__assign({}, state), { map: action.data });
        case SAVEDATAFILTER:
            return __assign(__assign({}, state), { dataFilter: action.data });
        case SAVEPOLYGON:
            return __assign(__assign({}, state), { listPolygon: action.data });
        case MERGEDATABOUDARIESTOLIST: {
            var boundariesData_1 = action.data;
            var listPlanningCategoriesAll = state.listPlanningCategoriesAll;
            listPlanningCategoriesAll.map(function (planningCategories) {
                planningCategories.plannings.map(function (planningObject) {
                    if (planningObject.id === boundariesData_1.planningId) {
                        planningObject.geomText = boundariesData_1.geomText;
                        planningObject.nameTb = boundariesData_1.nameTb;
                    }
                });
            });
            return __assign(__assign({}, state), { listPlanningCategoriesAll: listPlanningCategoriesAll });
        }
        case LIST_BOUNDARIES:
            return __assign(__assign({}, state), { listBoundaries: action.data });
        default:
            return state;
    }
}
exports.default = MapDataReducer;
//# sourceMappingURL=map-data.store.js.map